export default {
  //开奖控制
  prizeControl: {
    btn01: '新增',
    btn02: '查看',
    btn03: '编辑',
    btn04: '删除',
    btn05: '随机',
    error01: '确定要删除该条吗',
    error02: '确定要删除所选吗',
    error03: '请选择要删除的数据',
    error04: '期号格式有误，请重新输入',
    error05: '期号数有误',
    error06: '期号开始时间不允许小于当前时间',
    error07: '请将信息填写完整',
    form01: '所属平台',
    form02: '开奖期号',
    form03: '开始时间',
    form04: '结算时间',
    form05: '开奖号码',
    title01: '平台',
    title02: '期号',
    title03: '开奖时间',
    title04: '结束时间',
    title05: '状态',
    title06: '待开奖',
    title07: '已结算',
    title08: '开奖号码',
    title09: '更新时间',
    title10: '操作人',
    title11: '操作',
    title12: '全部',
    remark01: '期号设置规则:220101001表示22年01月01日001期'
  },
  //游戏胜率配置
  gameWinRateConfig: {
    btn01: '编辑',
    btn02: '取消',
    btn03: '确定',
    btn04: '移除',
    btn05: '详情',
    formTitle01: '游戏名称',
    formTitle02: '控制类型',
    formTitle03: '最高重试开奖次数',
    formTitle04: '重新开奖概率',
    formTitle05: '中奖金额/投注金额',
    formTitle06: '大于',
    formTitle07: '倍',
    formTitle08: '盈亏范围 盈亏/投注金额',
    formTitle09: '状态',
    formTitle10: '游戏盈亏控制',
    formTitle11: '用户盈亏控制',
    formTitle12: '投注盈亏控制',
    formTitle13: '启用',
    formTitle14: '禁用',
    remark01: '说明:开奖范围没有符合配置，则将重置开奖一次；均不符合则从其中取最相近的值开奖',
    error01: '请填写最高重试开奖次数',
    error02: '请填写盈亏范围',
    error03: '格式有误，只支持两位小数',
    error04: '设置的数值仅支持-100 到99999之间',
    error05: '最小值不允许大于最大值',
    error06: '请填写盈亏范围',
    error07: '最大值不允许小于最小值',
    error08: '请填写重新开奖概率',
    error09: '格式有误，数值只能大于0且只支持两位小数',
    error10: '设置的数值仅支持0 到100之间',
    error11: '请填写中奖金额/投注金额',
    error12: '设置的数值仅支持0 到99999之间',
    label01: '用户列表',
    label02: '确定要移除该条吗',
    label03: '确定要移除所选吗',
    label04: '用户信息',
    label05: '所属平台',
    label06: '添加时间',
    label07: '操作',
    label08: '平台',
    label09: '全部',
    label10: '移除成功',
    label11: '请选择要移除的数据',
    label12: '修改状态',
    label13: '确定要',
    label14: '游戏分类',
    label15: '选择控制类型',
    label16: '盈亏范围/重新开奖概率/倍数',
    label17: '至',
    label18: '用户',
  },
  //滚单
  rollList: {
    btn01: '详情',
    btn02: '编辑',
    btn03: '随机大',
    btn04: '随机小',
    btn05: '随机',
    btn06: '确定',
    btn07: '取消',
    table01: '玩法统计',
    table02: '游戏名称',
    table03: '玩法',
    table04: '用户数',
    table05: '投注数',
    table06: '投注金额',
    table07: '预计赢金额',
    table08: '暂无数据',
    table09: '按投注金额',
    table10: '按用户数',
    table11: '投注注数',
    table12: '所属平台',
    table13: '开奖期号',
    table14: '开始时间',
    table15: '结算时间',
    table16: '开奖号码',
    remark01: '期号设置规则:220101001表示22年01月01日001期',
    remark02: '该平台当前期号已设置过开奖号码：',
    remark03: '，是否进行覆盖',
    error01: '期号格式有误，请重新输入',
    error02: '期号数有误',
    error03: '期号结算时间不允许小于当前时间',
    error04: '请将信息填写完整',
    error05: '设置成功',
    label01: '立刻刷新',
    label02: '当前期号',
    label03: '开奖中',
    label04: '投注中',
    label05: '设置开奖',
    label06: '手动刷新',
    label07: '5秒',
    label08: '10秒',
    label09: '30秒',
    label10: '1分钟',
    label11: '平台',
    label12: '用户账号',
    label13: '游戏分类',
    label14: '期号',
    label15: '最小投注金额',
    label16: '关联订单号',
    label17: '游戏',
    label18: '投注时间',
    label19: '赔率',
    label20: '合计',
  },
  //用户控制
  userControl: {
    platformCode: '所属平台',
    account: '用户账号',
    userId: '用户ID',
    gameName: '游戏',
    controlType: '游戏控制类型/状态',
    status: '用户控制状态',
    remark: "备注",
    operate: "操作",
    all: "全部",
    controlTypeStatus: "游戏盈亏",
    controlTypeStatus2: "用户盈亏",
    controlTypeStatus3: "投注盈亏",

    placeholderPlatformCode: '请选择所属平台',
    placeholderAccount: '请输入用户账号',
    placeholderGame: '请选择游戏',
    placeholderRemark: '请输入备注',
    selectLabel: '是否批量修改用户控制状态为：',

  },

}
